import {motion} from 'framer-motion'
import {Link} from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import {navLi} from '../Variants/navVariants';
import '../CSS/nav.scss'
import '../CSS/NavMobile.scss'

const NavMobile = ({active, isActive}) =>{
    const {pathname} = useLocation();

    return(
        <motion.div className={`nav-links ${active ? 'active' : ''}`}
        variants={navLi}
        initial="initial"
        animate={active ? 'animate' : 'initial'}>
            <ul>
                <motion.li variants={navLi}
                initial="initial"
                animate={active ? 'animate' : 'initial'}>
                    <Link to="/" onClick={() => isActive(false)}>Home
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </motion.li>
                <motion.li variants={navLi}
                initial="initial"
                animate={active ? 'animate' : 'initial'}>
                    <Link to="/about" onClick={() => isActive(false)}>About
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/about" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                    
                </motion.li>
                <motion.li variants={navLi}
                initial="initial"
                animate={active ? 'animate' : 'initial'}>
                    <Link to="/projects" onClick={() => isActive(false)}>Projects
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/projects" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </motion.li>
                <motion.li variants={navLi}
                initial="initial"
                animate={active ? 'animate' : 'initial'}>
                    <Link to="/drawings" onClick={() => isActive(false)}>Drawings
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/drawings" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </motion.li>
                <motion.li variants={navLi}
                initial="initial"
                animate={active ? 'animate' : 'initial'}>
                    <Link to="/contact" onClick={() => isActive(false)}>Contact
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/contact" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </motion.li>
            </ul>
        </motion.div>
    )
}

export default NavMobile;